import {  Alert} from '../../types';

export const tagCriticalAlerts = (alerts: any): Alert[] => {
  return alerts.map((alert: any) => {
    if(alert.duration === 0) {
      alert.critical = true;
      return alert;
    } else {
      return alert;
    }
  })
}






// WEBPACK FOOTER //
// ./src/utils/alerts/tagCriticalAlerts.ts